const HTTP_PROTOCOL_REGEX = /^https?:\/\//i;
const GENERIC_SCHEME_REGEX = /^[a-z][a-z\d+\-.]*:/i;
const IPV4_REGEX = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
const DOMAIN_LABEL_REGEX = /^(?!-)[a-z0-9-]{1,63}(?<!-)$/i;

const normalizeForUrlParsing = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  return HTTP_PROTOCOL_REGEX.test(trimmed) ? trimmed : `https://${trimmed}`;
};

const hasValidHostname = (hostname) => {
  if (!hostname || hostname.length > 253) return false;

  if (IPV4_REGEX.test(hostname)) {
    return true;
  }

  if (!hostname.includes('.')) {
    return false;
  }

  return hostname.split('.').every((label) => DOMAIN_LABEL_REGEX.test(label));
};

export const normalizeWebsiteUrl = (value) => {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  // Reject non-http(s) schemes such as mailto:, ftp:, javascript:, etc.
  if (GENERIC_SCHEME_REGEX.test(trimmed) && !HTTP_PROTOCOL_REGEX.test(trimmed)) {
    return '';
  }

  const candidate = normalizeForUrlParsing(trimmed);
  if (!candidate) return '';

  try {
    const parsed = new URL(candidate);
    const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:';
    const hasNoCredentials = parsed.username === '' && parsed.password === '';
    const hasValidPort = parsed.port === '' || (Number(parsed.port) >= 1 && Number(parsed.port) <= 65535);
    if (!isHttp || !hasNoCredentials || !hasValidPort || !hasValidHostname(parsed.hostname)) {
      return '';
    }
    return parsed.toString();
  } catch (error) {
    return '';
  }
};

export const isValidWebsiteUrl = (value) => normalizeWebsiteUrl(value) !== '';
